import {TranslationResources} from "@spartacus/core";
import { es } from "./es/index"
import {en} from "./en";
import {pt} from "./pt";

export const gonvarriTranslations: TranslationResources = {
  en: {
    payment: {
      paymentTypes: {
        paymentType_ACCOUNT: 'Account'
      },
    },
    miniLogin: {
      signInRegister: 'Sign in',
    },
    ...en
  },
  es: {
    ...es
  },
  pt: {
    ...pt
  }
}

